// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__21z52","inputWrapper":"LoginForm_inputWrapper__2rvZ2"};